// src/hooks/useGoogleCalendar.js
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import api from '../api';

export const useGoogleCalendar = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { user } = useContext(AuthContext);

  const fetchEvents = async () => {

    if (!user?.token) {
      console.log('No user token available');
      return;
    }

    setLoading(true);
    try {
      console.log('Fetching calendar events...');
      const response = await api.get('/calendar/events');
      console.log('Calendar events response:', response.data);
      setEvents(response.data);
      setError(null);
    } catch (err) {
      console.error('Fetch events error:', err.response?.data || err.message);
      setError('Failed to fetch events');
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  const createEvent = async (eventData) => {
    if (!user?.token) {
      throw new Error('Not authenticated');
    }

    try {
      const response = await api.post('/calendar/events', eventData);
      await fetchEvents(); // Refresh events list
      return response.data;
    } catch (err) {
      console.error('Create event error:', err);
      throw err;
    }
  };

  useEffect(() => {
    if (user?.token) {
      fetchEvents();
    }
  }, [user]);

  const authorizeCalendar = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = `${window.location.origin}/calendar-callback`;
    
    const scope = encodeURIComponent('https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events');
    
    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&access_type=offline&prompt=consent`;
    
    window.location.href = googleAuthUrl;
  };

  

  return {
    events,
    loading,
    error,
    isAuthenticated: !!user?.token,
    createEvent,
    refreshEvents: fetchEvents,
    authorizeCalendar 
  };
};
